export const FIELDS = {
  short_input_max_length: 255,
  long_input_max_length: 5000,
  url_max_length: 2048,
} as const;

export type FieldName = keyof typeof FIELDS;
